import styled from "styled-components";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";

export const Container = styled(FlexColumn)`
    gap: 32px;
`;

export const Title = styled.div`
    ${setFontVariant("h5_2", colorsPalettes.carbon[500])}
`;

export const CardsContainer = styled(FlexRow)`
    justify-content: space-between;
`;

export const StyledButton = styled(Button)`
    align-self: flex-end;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
        ${setFontVariant("button", colorsPalettes.carbon[0])};
    }
`;
